import { useEffect, useState } from "react";

/**
 * Hook to calculate responsive skeleton count based on screen size
 * Matches the grid columns from ITEM_LIMIT.gridCardItemLimitClass:
 * - Mobile: 1 column
 * - SM (640px+): 2 columns
 * - MD (768px+): 3 columns
 * - LG (1024px+): 4 columns
 * - XL (1280px+): 5 columns
 */
export function useResponsiveSkeletonCount(rowsToShow = 2): number {
  const [skeletonCount, setSkeletonCount] = useState(10); // Default fallback

  useEffect(() => {
    const calculateSkeletonCount = () => {
      const width = window.innerWidth;
      let columns = 1;

      if (width >= 1280) {
        columns = 5; // xl
      } else if (width >= 1024) {
        columns = 4; // lg
      } else if (width >= 768) {
        columns = 3; // md
      } else if (width >= 640) {
        columns = 2; // sm
      } else {
        columns = 1; // mobile
      }

      setSkeletonCount(columns * rowsToShow);
    };

    calculateSkeletonCount();

    window.addEventListener("resize", calculateSkeletonCount);
    return () => window.removeEventListener("resize", calculateSkeletonCount);
  }, [rowsToShow]);

  return skeletonCount;
}
